import React from 'react';
import {Modal, Text, Button, HStack} from 'native-base';
import {message as t} from '../../../utils/messages';
import {StyleSheet} from 'react-native';

interface Props {
  title?: string;
  message?: string;
  onConfirm?: () => void;
  showingState?: any;
  forced?: boolean;
  buttonTitle?: string;
  disableAction?: boolean;
}

const InfoDialog = (props: Props) => {
  const {
    title,
    showingState,
    onConfirm: handleConfirmAction,
    message,
    forced,
    buttonTitle,
    disableAction,
  } = props;

  const [showDialog, setShowDialog] = showingState;

  const showCloseButton = () => {
    return !forced;
  };

  return (
    <Modal
      isOpen={showDialog}
      onClose={() => setShowDialog(false)}
      closeOnOverlayClick={false}
      isKeyboardDismissable={false}>
      <Modal.Content width="280" borderRadius={12}>
        {showCloseButton() && <Modal.CloseButton />}
        <Modal.Header style={styles.header}>
          <HStack justifyContent="center" alignItems="center">
            <Text fontSize="18" fontWeight={'extrabold'} color="#06355E">
              {title ? t(title) : t('advertend-dialog-message-default')}
            </Text>
          </HStack>
        </Modal.Header>
        <Modal.Body borderWidth={0}>
          <Text fontSize="14" color="#858597" textAlign={'center'}>
            {message ? t(message) : t('advertend-dialog-message-default')}
          </Text>
        </Modal.Body>
        <Modal.Footer
          style={styles.footer}
          alignItems="center"
          justifyContent="center">
          <Button
            variant="ghost"
            backgroundColor="#0088FF"
            _text={{color: '#FFFFFF'}}
            onPress={handleConfirmAction}
            width="90%"
            borderRadius={10}
            isDisabled={disableAction}>
            {t(buttonTitle ?? 'advertence-ok')}
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};

const styles = StyleSheet.create({
  header: {borderBottomWidth: 0},
  footer: {borderTopWidth: 0},
});

export default InfoDialog;
